<div class="updates">
  <h1 class="page_title">
    Publisher Updates<span>.</span>
    <p-progressSpinner
      class="spinner"
      *ngIf="isLoadingData"
      styleClass="w-2rem h-2rem"
      strokeWidth="2"
      fill="var(--surface-ground)"
      animationDuration="spinnerAnimationDuration">
    </p-progressSpinner>
  </h1>

  <div class="table-container">
    <!-- Filters -->
    <div class="filters" style="margin-bottom: 1rem;">
      <h2>Filters</h2>
      <div class="filter-row" style="display:flex; flex-wrap:wrap; gap:1rem;">
        <div class="filter-item">
          <label>Type</label>
          <p-dropdown
            [options]="typeOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="filters.record_type"
            style="width: 180px">
          </p-dropdown>
        </div>

        <div class="filter-item">
          <label>Publisher</label>
          <p-dropdown
            [options]="publisherOptions"
            [(ngModel)]="filters.publisher"
            style="width: 200px">
          </p-dropdown>
        </div>

        <div class="filter-item">
          <label>Status</label>
          <p-dropdown
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="filters.status"
            style="width: 200px">
          </p-dropdown>
        </div>

        <div class="filter-item">
          <label>Field</label>
          <input type="text" pInputText [(ngModel)]="filters.field" placeholder="e.g. hours_business" />
        </div>

        <div class="filter-item">
          <label>Account</label>
          <input type="text" pInputText [(ngModel)]="filters.account_ident" placeholder="account_ident" />
        </div>

        <div class="filter-item">
          <label>Store Code</label>
          <input type="text" pInputText [(ngModel)]="filters.store_code" placeholder="store_code" />
        </div>

        <div class="filter-item" style="min-width:260px">
          <label>Contains (response text)</label>
          <input type="text" pInputText [(ngModel)]="filters.text" placeholder='search "text" payload' />
        </div>
      </div>
    </div>

    <!-- ✅ OPEN THE TABLE -->
    <p-table
      id="updatesTable"
      styleClass="updates-table"
      [value]="filteredUpdates"
      [scrollable]="true"
      [resizableColumns]="true"
      [scrollHeight]="tableHeight"
      [paginator]="true" [rows]="25"
      dataKey="id"
      style="width: 100%"
      [rowExpandMode]="'single'">

      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th pResizableColumn pSortableColumn="created_at">
            Created <p-sortIcon field="created_at"></p-sortIcon>
          </th>
          <th pResizableColumn>Type</th>
          <th pResizableColumn pSortableColumn="publisher">
            Publisher <p-sortIcon field="publisher"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="field">
            Field <p-sortIcon field="field"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="status">
            Status <p-sortIcon field="status"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="status_code">
            Code <p-sortIcon field="status_code"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="account_ident">
            Account <p-sortIcon field="account_ident"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="store_code">
            Store Code <p-sortIcon field="store_code"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-u let-expanded="expanded">
        <tr>
          <td>
            <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-sm"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    pRowToggler [pRowToggler]="u"></button>
          </td>
          <td>{{ u.created_at | date:'yyyy-MM-dd HH:mm' }}</td>
          <td>{{ extractRecordType(u.id) | titlecase }}</td>
          <td>{{ u.publisher | titlecase }}</td>
          <td><code>{{ u.field }}</code></td>
          <td>{{ u.status | titlecase  }}</td>
          <td>
            <span class="status-code"
                  [ngClass]="{ 'status-green': u.status_code === 200,
                               'status-blue':  u.status_code === 202,
                               'status-red':   u.status_code !== 200 && u.status_code !== 202 }">
              {{ u.status_code }}
            </span>
          </td>
          <td>{{ u.account_ident }}</td>
          <td>{{ u.store_code }}</td>
        </tr>
      </ng-template>

      <!-- Row expansion -->
      <ng-template pTemplate="rowexpansion" let-u>
        <tr>
          <td colspan="9">
            <div class="details-card">
              <!-- Result -->
              <div class="details-section">
                <h4>Result</h4>
                <div class="result-box" *ngIf="u.text as t; else noText">{{ t }}</div>
                <ng-template #noText><div class="muted">No response text</div></ng-template>
              </div>

              <!-- Values only for updates -->
              <div class="details-section" *ngIf="hasValues(u)">
                <h4>Values</h4>
                <div class="values-grid">
                  <div class="value-block">
                    <div class="label">Old</div>
                    <pre class="json-block">{{ u.old_value | json }}</pre>
                  </div>
                  <div class="value-block">
                    <div class="label">New</div>
                    <pre class="json-block">{{ u.new_value | json }}</pre>
                  </div>
                  <div class="value-block">
                    <div class="label">Submitted</div>
                    <pre class="json-block">{{ u.submitted_value | json }}</pre>
                  </div>
                </div>
              </div>

              <!-- Meta -->
              <div class="details-section">
                <h4>Meta</h4>
                <dl class="meta-grid">
                  <div>
                    <dt>Type</dt>
                    <dd>{{ extractRecordType(u.id) }}</dd>
                  </div>
                  <div>
                    <dt>ID</dt>
                    <dd class="mono">{{ u.id }}</dd>
                  </div>
                  <div>
                    <dt>Process</dt>
                    <dd class="mono">{{ u.publisher_process_id || '—' }}</dd>
                  </div>
                  <div>
                    <dt>Account</dt>
                    <dd>{{ u.account_ident }}</dd>
                  </div>
                  <div>
                    <dt>Store Code</dt>
                    <dd>{{ u.store_code }}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table> <!-- ✅ CLOSE THE TABLE -->
  </div>
</div>
